import { File } from './types';
import React from 'react';

export function useFetchFileContents(file: File) {
  const [fileContents, setFileContents] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [hasError, setHasError] = React.useState(false);

  React.useEffect(() => {
    const fetchFile = async () => {
      setHasError(false);
      setIsLoading(true);

      try {
        // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
        const res = await fetch(file.downloadUrl);
        const text = await res.text();
        // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
        setFileContents(text);
      } catch (error) {
        console.error('Error fetching file contents', error);
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFile();
  }, [file.downloadUrl]);

  return {
    fileContents,
    isLoading,
    hasError,
  };
}
